import React, { useCallback } from "react";
import { formatISO } from "date-fns";
import { FinancialDocumentCounterparty } from "@common/types/financialDocument";
import { useStateAwareNavigate } from "@hooks/useStateAwareNavigate";
import { createCounterpartiesUrl } from "@components/settings/Directory/lib/counterpartiesUrl";
import { FinancialDocumentLinkRow } from "./FinancialDocumentLinkRow";

interface Props {
    counterparty: FinancialDocumentCounterparty;
    documentCreatedAt: Date;
}

export const FinancialCounterpartyLink: React.FC<Props> = ({
    counterparty,
    documentCreatedAt,
}) => {
    const navigate = useStateAwareNavigate();

    const handleClick = useCallback(() => {
        navigate(
            createCounterpartiesUrl({
                counterpartyId: counterparty.id,
            }),
        );
    }, [counterparty.id, navigate]);

    return (
        <FinancialDocumentLinkRow
            dateIso={formatISO(documentCreatedAt)}
            description={counterparty.name}
            testId="financial-document-counterparty-item"
            dateTestId="financial-document-counterparty-item-date"
            descriptionTestId="financial-document-counterparty-item-name"
            view={{
                onClick: handleClick,
                tooltip: "View counterparty",
                testId: "financial-document-counterparty-view-button",
            }}
        />
    );
};
